import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

export const Footer = styled.footer<{ $pb?: number }>`
  width: 100%;
  padding: 24px 16px;
  background-color: #f1f1f1;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #919191;

  ${({ $pb, theme }) =>
    $pb &&
    css`
      @media screen and (max-width: ${theme?.mobileWidth}px) {
        padding-bottom: ${$pb}px;
      }
    `}

  ${darkMode(css`
    background-color: ${darkPalette.surface};
    color: ${darkPalette.textTertiary};
  `)}
`;

export const Text = styled.p`
  max-width: 430px;
  margin: 0 auto;
  white-space: pre-line;

  & + & {
    margin-top: 16px;
  }
`;

export const Links = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 16px;
`;

export const Link = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;
  color: #444343;
  cursor: pointer;

  ${darkMode(css`
    color: ${darkPalette.textSecondary};
  `)}
`;
